module.exports = __webpack_public_path__ + "img/SKMJ_limit8.d442f3ed.jpg";